import React from "react";
import { Button } from "@culturehq/components";
import { Trans } from "app/utils";

import { TimeDiff } from "components/common/Time";
import ChqModalConfirmDelete from "components/common/ChqModalConfirmDelete";

import DefaultPromptModal from "./VirtualBackgroundModal";
import { VirtualBackground } from "./VirtualBackgroundTypes";

interface VirtualBackgroundRowProps {
  virtualBackground: VirtualBackground;
  onUpdate: (virtualBackground: VirtualBackground) => void;
  onDelete: (virtualBackground: VirtualBackground) => void;
}

const VirtualBackgroundRow = ({
  virtualBackground,
  onUpdate,
  onDelete
}: VirtualBackgroundRowProps) => {
  const { url, thumbnail, mediaType, position, createdAt, updatedAt } = virtualBackground;
  const mediaUrl = thumbnail || url;

  return (
    <tr>
      <td>
        <img className="StoryTable-Details__Image" src={mediaUrl} alt="" />
      </td>
      <td>
        <Trans>{mediaType}</Trans>
      </td>
      <td>
        <Trans>{position}</Trans>
      </td>
      <td>
        <TimeDiff time={createdAt} />
      </td>
      <td>
        <TimeDiff time={updatedAt} />
      </td>
      <td className="Actions-column">
        <DefaultPromptModal virtualBackground={virtualBackground} onUpdate={onUpdate}>
          {(onTrigger: any) => (
            <Button icon="edit-outlined" onClick={onTrigger} inverted />
          )}
        </DefaultPromptModal>
        <ChqModalConfirmDelete
          onAccept={() => onDelete(virtualBackground)}
          trigger={(onTrigger: any) => (
            <Button icon="trash-a-outlined" onClick={onTrigger} inverted />
          )}
        >
          <Trans>
            Are you sure you would like to delete this virtual background?
          </Trans>
        </ChqModalConfirmDelete>
      </td>
    </tr>
  );
};

export default VirtualBackgroundRow;
